import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SignOutComponent } from './sign-out/sign-out.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FuseSharedModule } from '@fuse/shared.module';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PrimengModule } from 'app/shared/modules/primeng.module';
import { ChangeUsernameComponent } from './change-username/change-username.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FlexLayoutModule } from '@angular/flex-layout';


@NgModule({
  declarations: [SignInComponent, SignUpComponent, SignOutComponent, ForgotPasswordComponent, ResetPasswordComponent, ChangePasswordComponent, ChangeUsernameComponent],
  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    NgxMaskModule.forRoot(),
    PrimengModule,
    FuseSharedModule,
    MatToolbarModule,
    FlexLayoutModule
  ], exports: [
    ChangePasswordComponent,
    ChangeUsernameComponent
  ]
})
export class AuthenticationModule { }
